import { useMemo }  from 'react';
import { 
  groupUrl, 
  deepLinkTarget,
}                   from 'utils/constants'
import { objType, userInfoType }  from 'types';

const dev = process.env.NODE_ENV === 'development';

const useDenyAccess = (
   guest:           boolean,
   goToVideoOnce:   boolean,
   dataUpdateState: objType,
   userInfo:        userInfoType
) => {


  const [showLoader, showSigninButton, showDenyAccess] = useMemo(() => {    

    const showLoader_       = ((!groupUrl && !dataUpdateState.content) || (!!deepLinkTarget && !dataUpdateState.final && !goToVideoOnce && !dev));
    const showSigninButton_ = !groupUrl && !guest && !deepLinkTarget && userInfo.userLogedIn === 'false' && !!userInfo.permissionResolved && !!userInfo.userExists;
    // deny only after permissions resolved explicitly false
    const showDenyAccess_   = false;
//
    return [
      showLoader_,
      showSigninButton_,
      showDenyAccess_,
    ]

  },[guest, goToVideoOnce, userInfo, dataUpdateState])


  return {
    showLoader,
    showSigninButton,
    showDenyAccess,
  }
}

export default useDenyAccess;
